import { useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { Button, Modal, Popup, trackEvent, useMediaQuery } from '@offerzen/pinata'
import SendTermsContent from './SendTermsContent'

import styles from './styles'

const trackClick = () => {
  trackEvent(
    'Company:T&Cs',
    {
      source: 'company terms page',
      action: 'clicked send terms',
    },
  )
}

const SendTerms = ({ companyId, token, isModalVisibleInitialState = false, buttonTheme }) => {
  const [isModalVisible, setIsModalVisible] = useState(isModalVisibleInitialState)
  const [isLoading, setIsLoading] = useState(false)
  const { isDesktopOrLarger } = useMediaQuery()

  return (
    <>
      <strong>Not authorised to accept our terms on behalf of your company?</strong>
      <div className={styles.row}>
        <p className={styles.explainerText}>
          If another team member is required to review and accept our terms, you can send our terms directly to them.
        </p>
        <Button
          label="Send terms"
          variant="outlined"
          size="medium"
          theme={buttonTheme}
          className={styles.button}
          onClick={() => {
            setIsModalVisible(true)
            trackClick()
          }}
        />
      </div>

      {createPortal(
        <Choose>
          <When condition={isDesktopOrLarger}>
            <Modal
              size="medium"
              hideModal={() => setIsModalVisible(false)}
              visible={isModalVisible}
              preventClose={isLoading}
            >
              {({ hideModal }) => (
                <SendTermsContent
                  hideWrapper={hideModal}
                  token={token}
                  companyId={companyId}
                  setIsLoading={setIsLoading}
                  title="Send terms to be accepted"
                />
              )}
            </Modal>
          </When>
          <Otherwise>
            <Popup
              hidePopup={() => setIsModalVisible(false)}
              visible={isModalVisible}
              preventClose={isLoading}
              theme="light"
              title="Send terms to be accepted"
            >
              {({ hidePopup }) => (
                <SendTermsContent
                  hideWrapper={hidePopup}
                  token={token}
                  companyId={companyId}
                  setIsLoading={setIsLoading}
                />
              )}
            </Popup>
          </Otherwise>
        </Choose>,
        document.getElementById('react-modal'),
      )}
    </>
  )
}

SendTerms.propTypes = {
  companyId: PropTypes.string.isRequired,
  token: PropTypes.string,
  isModalVisibleInitialState: PropTypes.bool,
  buttonTheme: PropTypes.string,
}

export default SendTerms
